export default __webpack_public_path__ + "static/media/Path509@2x.955eafbf.png";